import { ReactNode } from 'react';
export enum TimeGranularityOptionValues {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
}

export type ConsumptionVsTimeDataPoint = {
  day: number;
  value: number | null;
};

export enum SearchType {
  ALL = 'all',
  STATUS = 'wellStatus',
  WELLNAME = 'wellName',
  RIGNAME = 'rigName',
  COUNTRY = 'country',
}

export enum RigNames {
  MAERSKVOYAGER = 'maerskvoyager',
  QUENGUELA = 'quenguela',
  DS15 = 'ds15',
  MAERSKVIKING = 'maerskviking',
  NORTHALWYN = 'northalwyn',
}

export type unitSelectionOptions = {
  label: string | ReactNode;
  value: number;
};

export type generatorLegends = { numberGenerators: boolean; globalAverageLoad: boolean };
export type fuelConsumptionLegends = {
  dailyConsumption: boolean;
  cumulativeConsumption: boolean;
  averageDailyConsumption: boolean;
};
